<div class="footer">
  <div class="container">
    <div class="row mt-3">
      <div class="col-6 pb-1 mt-4 mb-4">
        <img src="assets/images/logo-white.png" alt="Smile Generation" width="197" height="71"/>
      </div>
      <div class="col-6 pb-1 mt-5 mb-4">
        <img src="assets/images/wellfit-plans-white.png" alt="Wellfit Plans" class="float-end" *ngIf="this.em.selectedState.abbr !== 'WA'"/>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class=" white-hr mt-2 mb-2"></div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-12">
        <p class="footer-text">
          Copyright © 2024 Wellfit Plans, LLC. All Rights Reserved. • Irving, TX, USA • <a href="https://wellfit.com/wellfits-terms-of-service/" target="_blank">Terms of Service</a> • <a href="https://wellfit.com/wellfits-privacy-policy/" target="_blank">Privacy Policy</a>
        </p>
        <p class="footer-text">
          THIS PLAN IS NOT INSURANCE and is not intended to replace health insurance.
        </p>
        <p class="footer-text">
          {{footerText}}
        </p>
        <p class="footer-text">
          Not valid in the state of WA or VT.
        </p>
        <p class="footer-text">
          <a href="https://wellfit.com/wellfits-california-consumer-privacy-policy/" target="_blank">CALIFORNIA CONSUMER PRIVACY ACT</a> Learn more about new data privacy rights for California Residents
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-12 m-xl-5">&nbsp;</div>
    </div>
  </div>
</div>
